module.exports = __webpack_public_path__ + "static/media/prom_vorota.1b2f4b56.jpg";